module.exports = __webpack_public_path__ + "306-29c9df097d671326618da3322f755365.png";


//////////////////
// WEBPACK FOOTER
// ./assets/teams/306.png
// module id = 1203
// module chunks = 0 1